import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import { GridContext } from '@bingads-webui-grid/grid-context';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { useCallback, useContext, useEffect } from 'react';
import { fetchLiftExperimentCampaigns } from '../../../fetch/lift-experiment-campaigns';

export const SelectCampaignsGridDataSource = () => {
  const { state, dispatch } = useContext(GridContext);
  const i18n = useContext(I18nContext);
  const { scope } = useContext(ScopeContext);

  const getOrderBy = useCallback((column) => {
    if (!column.fieldName) {
      return undefined;
    }

    return `${column.fieldName} ${column.isSortDescending ? 'DESC' : 'ASC'}`;
  }, []);

  const onSuccess = useCallback((response) => {
    dispatch({ type: 'FINISH_LOAD_DATA', payload: { items: response.value, totalCount: response['@odata.count'] } });
  }, [dispatch]);
  const onFailure = useCallback((message) => {
    const alertHelper = new AlertHelper({ i18n });
    alertHelper.showError(message);
  }, [i18n]);

  useEffect(() => {
    const orderBy = getOrderBy(state.sortedColumn);
    dispatch({ type: 'START_LOAD_DATA' });
    fetchLiftExperimentCampaigns(scope.values, {
      query: {
        $count: true,
        $top: state.pagination.pageSize,
        $skip: ((state.pagination.pageNumber - 1) * state.pagination.pageSize),
        $filter: state.editableFilter,
        ...(orderBy ? { $orderby: orderBy } : {}),
      },
      onSuccess,
      onFailure,
    });
  }, [dispatch, getOrderBy, onFailure, onSuccess, state.editableFilter, state.pagination, state.sortedColumn, scope.values]);

  return null;
};
